import LogoAnimated from "./LogoAnimated";
export default LogoAnimated;